import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../../shared/components/button/CreateButtonTrigger";
import AddCCSectionRoleForm from "./AddCCSectionRoleForm";

const AddCCSectionRoleDialog = ({ onSubmitHandler, roles }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="Añadir rol"
      description="Añadir un rol a una sección del Control Centre"
      content={
        <AddCCSectionRoleForm onSubmitHandler={onSubmit} roles={roles} />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default AddCCSectionRoleDialog;
